import { create } from 'zustand';

const useOfferStore = create((set, get) => ({
  // State
  offers: [],
  onboardingTasks: [],
  contracts: [],
  loading: false,
  error: null,

  // Actions
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Add specific actions here
}));

export default useOfferStore;